import { AppIconTooltip } from '@/ui/icon-tooltip';
import { FlexContainer } from '@/ui/styled-ui';
import { InputSwitch } from 'primereact/inputswitch';
import { InputTextarea } from 'primereact/inputtextarea';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditorSidebarLabel, EditorSidebarPanel } from './EditorSidebar';

type AiCustomizationPanelProps = {
  enabled: boolean;
  instructions: string;
  onToggle: (enabled: boolean) => void;
  onInstructionsChange: (instructions: string) => void;
  /** Tooltips attach by target id, which must be unique on the page. */
  tooltipTarget: string;
  /** Each editor names what it is customizing — a slide, a question. */
  tooltipKey: string;
  disabledKey: string;
};

export const AiCustomizationPanel: React.FC<AiCustomizationPanelProps> = ({
  enabled,
  instructions,
  onToggle,
  onInstructionsChange,
  tooltipTarget,
  tooltipKey,
  disabledKey,
}) => {
  const { t } = useTranslation();

  return (
    <EditorSidebarPanel
      header={
        <FlexContainer justify="flex-start" align="center" gap={0}>
          {t('content.contentEditor.aiCustomizationInstructions')}
          <AppIconTooltip target={tooltipTarget} content={t(tooltipKey)} />
        </FlexContainer>
      }
    >
      <FlexContainer justify="space-between" align="center" className="mb-3">
        <EditorSidebarLabel>
          {enabled
            ? t('content.contentEditor.aiCustomizationInstructions.enabled')
            : t(disabledKey)}
        </EditorSidebarLabel>
        <InputSwitch
          checked={enabled}
          onChange={(e) => onToggle(e.value ?? false)}
        />
      </FlexContainer>
      {enabled && (
        <InputTextarea
          className="w-full"
          rows={4}
          placeholder={t(
            'content.contentEditor.aiCustomizationInstructions.placeholder',
          )}
          value={instructions}
          onChange={(e) => onInstructionsChange(e.target.value)}
        />
      )}
    </EditorSidebarPanel>
  );
};
